import React from 'react';

const FullHeight = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <mask
            id="mask0_2017_187"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={200}
            height={117}
            >
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="white"
            />
            </mask>
            <g mask="url(#mask0_2017_187)">
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="#404040"
            />
            <path
                d="M106.635 38.2694C111.664 38.2694 115.74 34.1932 115.74 29.165C115.74 24.1367 111.664 20.0605 106.635 20.0605C101.607 20.0605 97.531 24.1367 97.531 29.165C97.531 34.1932 101.607 38.2694 106.635 38.2694Z"
                fill="#E66819"
            />
            <g opacity={0.59}>
                <path
                d="M183.561 71.8842L173.155 84.306C169.727 88.3968 172.636 94.6277 177.973 94.6277H228.299C233.128 94.6277 236.153 89.4085 233.753 85.218L221.889 64.5068C219.755 60.7823 214.599 60.2447 211.742 63.4488L203.68 72.4937C201.456 74.9886 197.668 75.3068 195.059 73.2177L192.307 71.0141C189.64 68.8782 185.755 69.2645 183.561 71.8842Z"
                fill="#818181"
                />
                <path
                opacity={0.18}
                d="M7.56668 59.2559C34.0715 59.2559 55.5579 37.7695 55.5579 11.2647C55.5579 -15.2402 34.0715 -36.7266 7.56668 -36.7266C-18.9382 -36.7266 -40.4246 -15.2402 -40.4246 11.2647C-40.4246 37.7695 -18.9382 59.2559 7.56668 59.2559Z"
                fill="#E66819"
                />
                <path
                d="M7.47625 29.9862C17.7101 29.9862 26.0062 21.69 26.0062 11.4562C26.0062 1.22241 17.7101 -7.07373 7.47625 -7.07373C-2.75757 -7.07373 -11.0537 1.22241 -11.0537 11.4562C-11.0537 21.69 -2.75757 29.9862 7.47625 29.9862Z"
                fill="#E66819"
                />
            </g>
            <path
                d="M69.446 62.3423H130.4"
                stroke="white"
                strokeWidth={4.62938}
                strokeLinecap="round"
            />
            <path
                d="M50.6199 72.8354H91.667"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M129.937 72.8354H147.22"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M100.926 72.8354H120.678"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M93.5189 83.3286H54.9407C53.2363 83.3286 51.8545 84.7104 51.8545 86.4149V94.4391C51.8545 96.1436 53.2363 97.5254 54.9407 97.5254H93.5189C95.2234 97.5254 96.6052 96.1436 96.6052 94.4391V86.4149C96.6052 84.7104 95.2234 83.3286 93.5189 83.3286Z"
                fill="#E66819"
            />
            <path
                d="M64.5081 90.2729H83.6428"
                stroke="white"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M143.207 83.3286H104.629C102.925 83.3286 101.543 84.7104 101.543 86.4149V94.4391C101.543 96.1436 102.925 97.5254 104.629 97.5254H143.207C144.912 97.5254 146.294 96.1436 146.294 94.4391V86.4149C146.294 84.7104 144.912 83.3286 143.207 83.3286Z"
                fill="#767676"
            />
            <path
                d="M114.197 90.2729H133.332"
                stroke="white"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M96.4815 24.5758C97.4846 23.8829 98.8117 23.8829 99.8147 24.5758L103.687 27.2509L107.428 30.1072C108.397 30.8469 108.807 32.1089 108.458 33.2771L107.11 37.7864L105.55 42.2269C105.146 43.3769 104.072 44.1571 102.853 44.1858L98.1481 44.2978L93.4428 44.1858C92.2244 44.1571 91.1507 43.3769 90.7464 42.2269L89.1859 37.7864L87.8385 33.2771C87.4894 32.1089 87.8996 30.8469 88.8684 30.1072L92.6092 27.2509L96.4815 24.5758Z"
                stroke="white"
                strokeWidth={4.01213}
            />
            </g>
        </svg>
    )
}

export default FullHeight;